import { useLogoutMutation } from "app/api/authApi";
import useCart from "hooks/cart/useCart";
import useLocaleNavigate from "hooks/reactRouterWrappers/useLocaleNavigate";
import { useTranslation } from "react-i18next";
import { logout as AuthSliceLogout } from "redux/auth/authSlice";
import { useDispatch, useSelector } from "redux/hooks";
import {
	COOKIE_CUSTOMER_IDENTIFIER,
	COOKIE_SHOP_TOKEN,
	COOKIE_CART_ID
} from "utilities/consts";
import { deleteAppCookie } from "utilities/cookies";
import PathTranslationKey from "utilities/paths";
import { useLazyGetCartFromDBQuery } from "app/api/cart/cartApi";

const useLogout = (replace?: boolean, to?: string) => {
	const { t } = useTranslation();
	const { identifier } = useSelector((state) => state.auth);
	const [triggerGetCartFromDB] = useLazyGetCartFromDBQuery();

	const dispatch = useDispatch();
	const localeNavigate = useLocaleNavigate();

	const cart = useCart();

	const [logout] = useLogoutMutation();

	const doLogout = async (storeHash?: string, deleteCart = true) => {
		// const host = window.location.hostname.startsWith(".") ? window.location.hostname : `.${window.location.hostname}`;

		if (cart.cart?.id){
			const dbCart = await triggerGetCartFromDB(cart.cart?.customer_id).unwrap();

			if (deleteCart && dbCart?.id !== cart.cart?.id) 
			await cart.deleteCart();

		}

		if (identifier?.storeHash) {
			await logout(storeHash)
				.unwrap()
				.catch((error) => {
					return;
				});
		}

		await deleteAppCookie(COOKIE_CUSTOMER_IDENTIFIER);
		await deleteAppCookie(COOKIE_SHOP_TOKEN);


		dispatch(AuthSliceLogout());

		const bcCheckoutHostname = sessionStorage.getItem("bc_checkout_hostname");
		if (bcCheckoutHostname) {
			sessionStorage.removeItem("bc_checkout_hostname");
			fetch(`https://${bcCheckoutHostname}/login.php?action=logout`, {
				mode: "no-cors",
				credentials: "include",
			}).catch(() => {});
		}

		const accountsUrl = t(PathTranslationKey.ACCOUNT_OVERVIEW);
		const signOutUrl = t(PathTranslationKey.SIGN_OUT);

		const path = window.location.pathname;

		if (path.includes(accountsUrl) || path.includes(signOutUrl)) {
			localeNavigate(to ? to : t(PathTranslationKey.SIGN_IN), {
				replace: replace,
			});
		}
	};

	return (storeHash?: string, deleteCart = true) => {
		doLogout(storeHash, deleteCart);
	};
};

export default useLogout;